export default "__VITE_ASSET__oMuY1c1V__"